/**
 * Excel related names constants
 */

export const IMPORT_MODAL_TITLE = 'LanguageService::Action:ExcelImport.Title';
export const IMPORT_AGAIN_LABEL = 'LanguageService::Action:ExcelImport.ImportAgain';
export const IMPORT_MAX_SIZE_MB = 2;
